import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import styles from './workflowstatus.module.scss';
import { DevelopmentAPI } from 'pages/workspace/process/development/development.service';
import { KoSelect, KoText } from 'packages';


export default function WorkFlowStatus({ value, onChange }) {
  const { workspaceId } = useParams();
  const [workspaceRecord, setWorkspaceRecord] = useState();

  useEffect(() => {
    if (workspaceId) {
      getWorkspaceById(workspaceId);
    }
  }, [workspaceId]);

  const getWorkspaceById = async(id) => {
    try {
      const data = await DevelopmentAPI.getWorkspaceById(id);
      setWorkspaceRecord(data?.project);
    } catch (err) {
      console.error('Error fetching workspace:', err);
    }
  };

  const workflowOptions = (workspaceRecord?.template?.workflow || []).map(status => ({
    label: (
      <div className={styles.wrapper}>
        <div
          className={styles.status}
          style={{
            background: status.color,
            color: status.background
          }}
        />
        <KoText text={status.label} />
      </div>
    ),
    value: status.value,
    key: status.value
  }));

  return (
    <KoSelect
      value={value}
      showSearch
      onChange={onChange}
      placeholder='Select status'
      options={workflowOptions}
    />
  );
}
